type Positionable = { position: number }

export default function calculateNewPosition<T extends Positionable>(
  index: number,
  list: T[]
): number {
  if (list.length === 0) {
    return 1
  }
  if (index === 0) {
    return list[0].position / 2
  }
  if (index === list.length) {
    return list[list.length - 1].position + 1
  }
  return (list[index - 1].position + list[index].position) / 2
}
